import { TIERS } from "constants/pricing";
export const INFO_TOOLTIP_KEY = "pricingPage.tierAiBlock.tooltip";
// CRM classic (simplified) uses its own info-icon tooltip — credits are bundled
// into the plan rather than the WM "add more credits" message.
export const CRM_INFO_TOOLTIP_KEY = "pricingPage.crmAiBlock.tooltip";
export const SUBTITLE_TEMPLATE_KEY = "pricingPage.tierAiBlock.subtitle";
export const LIMITED_CHIP_KEY = "pricingPage.tierAiBlock.chips.limited";
export const CREDITS_PER_SEAT_LABEL_KEY = "pricingPage.tierAiBlock.creditsPerSeat.label";
export const CREDITS_PER_SEAT_LABEL_TOOLTIP_KEY = "pricingPage.tierAiBlock.creditsPerSeat.label.tooltip";
export const CREDITS_PER_SEAT_TOOLS_COUNT_KEY = "pricingPage.tierAiBlock.creditsPerSeat.toolsCount";
export const CREDITS_PER_SEAT_ENTERPRISE_TITLE_KEY = "pricingPage.tierAiBlock.creditsPerSeat.enterprise.title";
export const CREDITS_PER_SEAT_ENTERPRISE_CUSTOM_KEY = "pricingPage.tierAiBlock.creditsPerSeat.enterprise.customCredits";
export const CREDITS_PER_SEAT_GOVERNANCE_TITLE_KEY = "pricingPage.tierAiBlock.creditsPerSeat.governance.title";
export const CREDITS_PER_SEAT_GOVERNANCE_PERMISSIONS_KEY = "pricingPage.tierAiBlock.creditsPerSeat.governance.permissions";
export const CREDITS_PER_SEAT_GOVERNANCE_PERMISSIONS_TOOLTIP_KEY = "pricingPage.tierAiBlock.creditsPerSeat.governance.permissions.tooltip";
export const CREDITS_PER_SEAT_GOVERNANCE_SPEND_LIMITS_KEY = "pricingPage.tierAiBlock.creditsPerSeat.governance.spendLimits";
export const CREDITS_PER_SEAT_GOVERNANCE_SPEND_LIMITS_TOOLTIP_KEY = "pricingPage.tierAiBlock.creditsPerSeat.governance.spendLimits.tooltip";
export const CREDITS_PER_SEAT_YEARLY_SAVINGS_TOOLTIP_KEY = "pricingPage.tierAiBlock.creditsPerSeat.yearlySavings.tooltip";
export const CREDITS_PER_SEAT_SHARED_POOL_LABEL_KEY = "pricingPage.tierAiBlock.creditsPerSeat.sharedPool.label";
export const CREDITS_PER_SEAT_SHARED_POOL_UNAVAILABLE_KEY = "pricingPage.tierAiBlock.creditsPerSeat.sharedPool.unavailable";
export const CREDITS_PER_SEAT_SHARED_POOL_AMOUNT_SUFFIX_KEY = "pricingPage.tierAiBlock.creditsPerSeat.sharedPool.amountSuffix";
export const CREDITS_PER_SEAT_AMOUNT_SUFFIX_KEY = "pricingPage.tierAiBlock.creditsPerSeat.amountSuffix";
export const SIDEKICK_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/v1776602242/uploads/bhycfyw45ajulhuqcwc2.svg";
export const AI_COLUMNS_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/v1776936548/uploads/ytt11zblp6jubfjg3ntb.svg";
export const VIBE_APP_BUILDER_FEATURE = "vibeAppBuilder";
export const AI_FEATURES_CONFIG = {
    agentWorkforce: {
        labelKey: "pricingPage.credits.usage.agentWorkforce",
        icon: "https://dapulse-res.cloudinary.com/image/upload/v1776602195/uploads/uc0bjm5cmpvvi4zrqgtr.svg"
    },
    meetingNotetaker: {
        labelKey: "pricingPage.credits.usage.meetingNotetaker",
        icon: "https://dapulse-res.cloudinary.com/image/upload/v1776602110/uploads/d0eizmj7mlxz6ylrytgc.svg"
    },
    sidekickAssistant: {
        labelKey: "pricingPage.credits.usage.sidekickAssistant",
        icon: "https://dapulse-res.cloudinary.com/image/upload/v1776602242/uploads/bhycfyw45ajulhuqcwc2.svg"
    },
    workflowBuilder: {
        labelKey: "pricingPage.credits.usage.workflowBuilder",
        icon: "https://dapulse-res.cloudinary.com/image/upload/v1776602171/uploads/zhcvyyccemqzfzegprzz.svg"
    },
    vibeAppBuilder: {
        labelKey: "pricingPage.credits.usage.vibeAppBuilder",
        icon: "https://dapulse-res.cloudinary.com/image/upload/v1776602217/uploads/tanvwllethxdz3rhv0l4.svg"
    },
    aiColumns: {
        labelKey: "pricingPage.credits.usage.aiColumns",
        icon: "https://dapulse-res.cloudinary.com/image/upload/v1776936548/uploads/ytt11zblp6jubfjg3ntb.svg"
    }
};
const ALL_AI_FEATURES = [
    {
        key: "agentWorkforce"
    },
    {
        key: "meetingNotetaker"
    },
    {
        key: "sidekickAssistant"
    },
    {
        key: "vibeAppBuilder"
    },
    {
        key: "aiColumns"
    },
    {
        key: "workflowBuilder"
    }
];
export const TIER_AI_FEATURES = {
    [TIERS.BASIC]: [
        {
            key: "agentWorkforce",
            isLimited: true
        },
        {
            key: "sidekickAssistant"
        },
        {
            key: "vibeAppBuilder"
        }
    ],
    [TIERS.STANDARD]: [
        {
            key: "agentWorkforce"
        },
        {
            key: "meetingNotetaker"
        },
        {
            key: "sidekickAssistant"
        },
        {
            key: "vibeAppBuilder"
        },
        {
            key: "aiColumns"
        }
    ],
    [TIERS.PRO]: ALL_AI_FEATURES,
    [TIERS.ENTERPRISE]: ALL_AI_FEATURES
};
// Per-seat variant feature lists + shorter Figma labels. Basic gets 4 tools;
// Standard/Pro/Enterprise get the full 6 (including workflows).
export const CREDITS_PER_SEAT_AI_FEATURES = {
    [TIERS.BASIC]: [
        {
            key: "agentWorkforce"
        },
        {
            key: "meetingNotetaker"
        },
        {
            key: "sidekickAssistant"
        },
        {
            key: "vibeAppBuilder"
        }
    ],
    [TIERS.STANDARD]: ALL_AI_FEATURES,
    [TIERS.PRO]: ALL_AI_FEATURES,
    [TIERS.ENTERPRISE]: ALL_AI_FEATURES
};
export const CREDITS_PER_SEAT_FEATURE_LABEL_KEYS = {
    agentWorkforce: "pricingPage.tierAiBlock.creditsPerSeat.usage.agentWorkforce",
    meetingNotetaker: "pricingPage.tierAiBlock.creditsPerSeat.usage.meetingNotetaker",
    sidekickAssistant: "pricingPage.tierAiBlock.creditsPerSeat.usage.sidekickAssistant",
    vibeAppBuilder: "pricingPage.tierAiBlock.creditsPerSeat.usage.vibeAppBuilder",
    aiColumns: "pricingPage.tierAiBlock.creditsPerSeat.usage.aiColumns",
    workflowBuilder: "pricingPage.tierAiBlock.creditsPerSeat.usage.workflowBuilder"
};
export const getCreditsPerSeatFeatureLabelKey = (tierName, featureKey)=>{
    if (featureKey === "workflowBuilder" && tierName === TIERS.STANDARD) {
        return "pricingPage.tierAiBlock.creditsPerSeat.usage.workflowBuilder.standard";
    }
    if (featureKey === "workflowBuilder" && tierName === TIERS.ENTERPRISE) {
        return "pricingPage.tierAiBlock.creditsPerSeat.usage.workflowBuilder.enterprise";
    }
    return CREDITS_PER_SEAT_FEATURE_LABEL_KEYS[featureKey];
};
// CRM classic layout (simplified mode) renders a CRM-specific, icon-less list that
// is identical across Standard/Pro/Ultimate. See Figma CRM-pricing-2025-2026 node 5012-18115.
export const CRM_AI_FEATURES = [
    {
        key: "salesAgent",
        labelKey: "pricingPage.crmAiBlock.usage.salesAgent"
    },
    {
        key: "leadsAgent",
        labelKey: "pricingPage.crmAiBlock.usage.leadsAgent"
    },
    {
        key: "buildYourOwnAgent",
        labelKey: "pricingPage.crmAiBlock.usage.buildYourOwnAgent"
    },
    {
        key: "meetingPrepAgent",
        labelKey: "pricingPage.crmAiBlock.usage.meetingPrepAgent"
    },
    {
        key: "aiMeetingNotetaker",
        labelKey: "pricingPage.crmAiBlock.usage.aiMeetingNotetaker"
    },
    {
        key: "aiWorkAssistant",
        labelKey: "pricingPage.crmAiBlock.usage.aiWorkAssistant"
    },
    {
        key: "vibeAppBuilder",
        labelKey: "pricingPage.crmAiBlock.usage.vibeAppBuilder"
    },
    {
        key: "aiPoweredDataFields",
        labelKey: "pricingPage.crmAiBlock.usage.aiPoweredDataFields"
    },
    {
        key: "aiWorkflowBuilder",
        labelKey: "pricingPage.crmAiBlock.usage.aiWorkflowBuilder"
    }
];
// Per-tier removals from the CRM AI card list. AI workflow builder isn't
// available on Standard (matches the full feature matrix, where Standard shows
// "—" — only Pro/Ultimate get it). Basic renders no AI block at all.
export const CRM_AI_FEATURES_TIER_EXCLUSIONS = {
    [TIERS.STANDARD]: [
        "aiWorkflowBuilder"
    ]
};
export const TIER_BLOCK_CONFIG = {
    [TIERS.FREE]: {
        variant: "disabled",
        icon: "lock",
        titleKey: "pricingPage.tierAiBlock.free.title",
        subtitleKey: "pricingPage.tierAiBlock.free.subtitle"
    },
    [TIERS.BASIC]: {
        variant: "collapsible",
        icon: "basic",
        titleKey: "pricingPage.tierAiBlock.basic.title",
        defaultOpen: false,
        headingKey: "pricingPage.tierAiBlock.pro.heading"
    },
    [TIERS.STANDARD]: {
        variant: "collapsible",
        icon: "sidekick",
        titleKey: "pricingPage.tierAiBlock.standard.title",
        highlighted: true,
        defaultOpen: false,
        headingKey: "pricingPage.tierAiBlock.pro.heading"
    },
    [TIERS.PRO]: {
        variant: "collapsible",
        icon: "sidekick",
        titleKey: "pricingPage.tierAiBlock.pro.title",
        highlighted: true,
        defaultOpen: true,
        headingKey: "pricingPage.tierAiBlock.pro.heading"
    },
    [TIERS.ENTERPRISE]: {
        variant: "collapsible",
        icon: "enterprise-ai",
        titleKey: "pricingPage.tierAiBlock.enterprise.title",
        subtitleTemplateKey: "pricingPage.tierAiBlock.enterprise.subtitle",
        defaultOpen: false,
        headingKey: "pricingPage.tierAiBlock.pro.heading"
    }
};
